<!--suppress CssUnknownTarget, CssUnresolvedCustomProperty, CssInvalidPropertyValue, CssUnusedSymbol, ES6UnusedImports, JSUnfilteredForInLoop -->
<script>
	import lzstring from 'lz-string'
	import axios from 'axios'
	import { onMount, onDestroy } from 'svelte'
	import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap'
	import FullScreen from './FullScreen.svelte'
	import Image3D from './Image3D.svelte'
	import Accordion from './Accordion'

	export let development = false
	export let route = {}
	export let isFrame = false

	const token = atob('UncxWEJoSHQzYUFBQUFBQUFBQURZX203TElMaGFfUjFad1dLLWJtcFRDYW5qVmFnM25aQUh6SUotM2JzRnByWQ==')
	const key = atob('ZmEwYTkzNTA5OThjZGJhZjk4OTFkNDliM2RmMGZmYTY=')
	const igdb_url = 'https://cors-anywhere.herokuapp.com/https://api-v3.igdb.com'

	let database = {
		companies: [],
		platforms: []
	}

	let wallpapers = {
		data: {
			children: []
		}
	}

	let datafiles = []
	let entries = []

	let isFullScreen = false
	let isBackgroundDropdownOpen = false
	let showSettings = true
	let showDatafiles = false
	let showEntries = false
	let showGrid = false
	let showEmulator = false

	const fetch = async (url) => {
		const response = await axios(url)
		return await response.data
	}

	onMount(async () => {
		database = await fetch('assets/database/!index.json')
		wallpapers = await fetch('https://wallpapers.emupedia.net/data/filesystem.json')

		/*axios({
			url: `${igdb_url}/games`,
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'user-key': key
			},
			data: 'fields age_ratings,aggregated_rating,aggregated_rating_count,alternative_names,artworks,bundles,category,checksum,collection,cover,created_at,dlcs,expansions,external_games,first_release_date,follows,franchise,franchises,game_engines,game_modes,genres,hypes,involved_companies,keywords,multiplayer_modes,name,parent_game,platforms,player_perspectives,popularity,pulse_count,rating,rating_count,release_dates,screenshots,similar_games,slug,standalone_expansions,status,storyline,summary,tags,themes,time_to_beat,total_rating,total_rating_count,updated_at,url,version_parent,version_title,videos,websites;'
		}).then(response => {
			console.log(response.data)
		}).catch(err => {
			console.error(err)
		})*/
	})

	function onToggleEl(el) {
		switch (el) {
			case 'showDatafiles':
				showGrid = false
				showSettings = false
				showEntries = false
				showDatafiles = !showDatafiles
				showEmulator = false
				break;
			case 'showEntries':
				showSettings = false
				showEntries = !showEntries
				showDatafiles = false
				showEmulator = false
				break;
			case 'showGrid':
				showGrid = !showGrid
				break;
			case 'showSettings':
				showSettings = !showSettings
				showEntries = false
				showDatafiles = false
				showEmulator = false
				break;
		}
	}

	function loadSystem(search) {
		if (typeof database !== 'undefined') {
			if (typeof database.platforms !== 'undefined') {
				for (let i in database.platforms) {
					// noinspection JSUnresolvedVariable
					if (typeof database.platforms[i].systems !== 'undefined') {
						// noinspection JSUnresolvedVariable
						let system = database.platforms[i].systems.find(({name}) => name === search)

						if (typeof system !== 'undefined') {
							// noinspection JSUnresolvedVariable
							if (typeof system.datafiles !== 'undefined') {
								// noinspection JSUnresolvedVariable
								datafiles = system.datafiles
								showSettings = false
								showDatafiles = true
								showEntries = false
								break
							}
						}
					}
				}
			}
		}
	}

	async function loadDatafile(datafile) {
		entries = JSON.parse(lzstring.decompressFromUTF16(await fetch('assets/database/' + datafile))).entries
		showSettings = false
		showDatafiles = false
		showEntries = true
	}

	function loadEntry(entry) {
		console.log(entry)
	}

	function onSliderInit(node) {
		if (window.$sys.browser.isIE) {
		} else if (window.$sys.browser.isEdgeHTML) {
		} else if (window.$sys.browser.isChrome || window.$sys.browser.isOperaBlink || window.$sys.browser.isEdgeBlink || window.$sys.browser.isChromium) {
			node.style.background = 'linear-gradient(to right, #00c874 0%, #00c874 ' + ((node.value - node.min) / (node.max - node.min) * 100) + '%, #000 ' + ((node.value - node.min) / (node.max - node.min) * 100) + '%, #000 100%)'
		} else if (window.$sys.browser.isSafari || window.$sys.browser.isOperaPresto) {
			node.style.background = 'linear-gradient(to right, #00c874 0%, #00c874 ' + ((node.value - node.min) / (node.max - node.min) * 100) + '%, #000 ' + ((node.value - node.min) / (node.max - node.min) * 100) + '%, #000 100%)'
		} else if (window.$sys.browser.isFirefox || window.$sys.browser.isPaleMoon || window.$sys.browser.isBasilisk || window.$sys.browser.isKMeleon || window.$sys.browser.isNetscape) {
		} else {
		}
	}

	function onSliderInput() {
		if (window.$sys.browser.isIE) {
		} else if (window.$sys.browser.isEdgeHTML) {
		} else if (window.$sys.browser.isChrome || window.$sys.browser.isOperaBlink || window.$sys.browser.isEdgeBlink || window.$sys.browser.isChromium) {
			this.style.background = 'linear-gradient(to right, #00c874 0%, #00c874 ' + ((this.value - this.min) / (this.max - this.min) * 100) + '%, #000 ' + ((this.value - this.min) / (this.max - this.min) * 100) + '%, #000 100%)'
		} else if (window.$sys.browser.isSafari || window.$sys.browser.isOperaPresto) {
			this.style.background = 'linear-gradient(to right, #00c874 0%, #00c874 ' + ((this.value - this.min) / (this.max - this.min) * 100) + '%, #000 ' + ((this.value - this.min) / (this.max - this.min) * 100) + '%, #000 100%)'
		} else if (window.$sys.browser.isFirefox || window.$sys.browser.isPaleMoon || window.$sys.browser.isBasilisk || window.$sys.browser.isKMeleon || window.$sys.browser.isNetscape) {
		} else {
		}
	}
</script>

<!--
<header class="titlebar">
	<div class="drag-region">
		<div class="window-title"><span>ÐeKaÐeNcE Launcher 0.0.1</span></div>
		<div class="window-controls">
		<div class="minimize button"><span></span></div>
		<div class="maximize button"><span></span></div>
		<div class="restore button"><span></span></div>
		<div class="close button"><span></span></div>
		</div>
	</div>
</header>
-->

<FullScreen let:onToggle on:change={e => isFullScreen = e.detail.isFullScreen}>
	<main class="content">
		<div class="header blur">
			<div class="item row-1 column-1">
				<!--suppress HtmlUnknownTarget -->
				<!--<img class="icon" src="assets/images/logos/emuarchive/emuarchive-logo.svg" alt=""/>-->
			</div>
			<div class="item row-1 column-2"><span>EmuArchive</span></div>
			<div class="item row-1 column-3">
				<div class="spacer"></div>
				<div class="spacer"></div>
				<div class="spacer"></div>
				<!--suppress HtmlUnknownTarget -->
				<!--<img class="icon" src="assets/images/logos/emuarchive/emuarchive-logo.svg" alt=""/>-->
				<!--<div class="button minimize"></div>-->
				<!--<div class="button maximize"></div>-->
				<!--<div class="button restore"></div>-->
				<!--<div class="button exit"></div>-->
			</div>
			<div class="item row-2 column-1">
				<!--suppress HtmlUnknownTarget -->
				<!--<img class="icon" src="assets/images/logos/emuarchive/emuarchive-logo.svg" alt=""/>-->
			</div>
			<div class="item row-2 column-2"><span>News</span><span class="selected">Archive</span><span>Support</span><span>About</span></div>
			<div class="item row-2 column-3">
				<div class="spacer"></div>
				{#if !isFrame}
					<!--suppress JSUnresolvedVariable -->
					<div class="button {isFullScreen ? 'unfullscreen' : 'fullscreen'}" on:click={onToggle}></div>
				{:else}
					<div class="spacer"></div>
				{/if}
				<div class="button {showGrid ? 'list' : 'grid'}" on:click={() => onToggleEl('showGrid')}></div>
				<div class="button settings" on:click={() => onToggleEl('showSettings')}>
					<!--suppress HtmlUnknownTarget -->
					<img class="icon" src="assets/images/buttons/settings.svg" alt=""/>
				</div>
			</div>
		</div>

		<div class="game-container">
			<div class="game-list blur">
				<div class="list-container">
					{#await database}
						<p>...waiting</p>
					{:then data}
						<!--suppress JSUnresolvedVariable -->
						<Accordion>
						{#each data.platforms as platform }
							<!--suppress SvelteUnresolvedComponent, JSUnresolvedVariable -->
							<Accordion.Section title={platform.name}>
								{#if platform.systems}
									{#each platform.systems as system }
										{#if !system.hidden && system.datafiles && system.datafiles.length > 0}
											<a class="block" href="javascript:" on:click={() => loadSystem(system.name)}>{system.name}</a>
										{/if}
									{/each}
								{:else}
									Empty
								{/if}
							</Accordion.Section>
						{/each}
						</Accordion>
					{:catch error}
						<p>An error occurred!</p>
					{/await}
				</div>
			</div>
			<div class="game-details blur">
				{#if showSettings}
					<div class="list-container">
						<p><span class="background-selector">Background:</span>
							<Dropdown isOpen={isBackgroundDropdownOpen} toggle={() => (isBackgroundDropdownOpen = !isBackgroundDropdownOpen)}>
								<DropdownToggle caret>Lion</DropdownToggle>
								<DropdownMenu>
									<DropdownItem header>Default</DropdownItem>
									<DropdownItem>Lion</DropdownItem>
									{#if wallpapers.data.children.length > 0}
										{#each wallpapers.data.children as wallpaper}
											<DropdownItem header>{wallpaper.name}</DropdownItem>
											{#each wallpaper.children as wallpaper}
												<DropdownItem>{wallpaper.name}</DropdownItem>
											{/each}
										{/each}
									{/if}
								</DropdownMenu>
							</Dropdown>
						</p>
						<div class="background-zoom">Background Zoom:</div>
						<!--suppress HtmlFormInputWithoutLabel -->
						<input class="slider" type="range" min="10" max="60" value="50" use:onSliderInit on:input={onSliderInput}/>

						<div class="background-blur">Background Blur:</div>
						<!--suppress HtmlFormInputWithoutLabel -->
						<input class="slider" type="range" min="1" max="100" value="50" use:onSliderInit on:input={onSliderInput}/>

						<div class="background-brightness">Background Brightness:</div>
						<!--suppress HtmlFormInputWithoutLabel -->
						<input class="slider" type="range" min="1" max="100" value="50" use:onSliderInit on:input={onSliderInput}/>

						<div class="background-opacity">Panel Opacity:</div>
						<!--suppress HtmlFormInputWithoutLabel -->
						<input class="slider" type="range" min="1" max="100" value="50" use:onSliderInit on:input={onSliderInput}/>
					</div>
				{:else if showDatafiles && datafiles.length > 0}
					<div class="list-container">
						{#each datafiles as datafile}
							{#if showGrid}
								<Image3D url="javascript:" image="assets/images/wallpapers/lion.jpg" on:click={() => loadDatafile(datafile)} name={datafile} />
							{:else}
								<a class="block" href="javascript:" on:click={() => loadDatafile(datafile)}>{datafile}</a>
							{/if}
						{/each}
					</div>
				{:else if showEntries && entries.length > 0}
					<div class="list-container">
						{#each entries as entry}
							{#if showGrid}
								<Image3D url="javascript:" image="assets/images/wallpapers/lion.jpg" on:click={() => loadEntry(entry)} name={entry.name} />
							{:else}
								<a class="block" href="javascript:" on:click={() => loadEntry(entry)}>{entry.name}</a>
							{/if}
						{/each}
					</div>
				{:else if showEmulator}
					<div class="iframe-wrapper">
						<!--suppress HtmlUnknownTarget -->
						<iframe class="iframe" title="c64" src="assets/emulators/c64_tiny8bit/index.html"></iframe>
					</div>
				{/if}
			</div>
		</div>
	</main>
</FullScreen>